import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';
import { ShortcutService } from '@app/core';

/** The keys of the app with the i18n key of what they do. */
export const SHORTCUTS: { keys: string[]; label: string }[] = [
  { keys: ['Ctrl/⌘', 'K'], label: 'shortcuts.globalSearch' },
  { keys: ['/'], label: 'shortcuts.queryBar' },
  { keys: ['F'], label: 'shortcuts.builder' },
  { keys: ['Enter', 'Tab'], label: 'shortcuts.commit' },
  { keys: ['Enter'], label: 'shortcuts.search' },
  { keys: ['Ctrl/⌘', 'Enter'], label: 'shortcuts.searchCtrl' },
  { keys: ['Backspace'], label: 'shortcuts.removeChip' },
  { keys: ['←', '→'], label: 'shortcuts.moveChip' },
  { keys: ['Esc'], label: 'shortcuts.escape' },
  { keys: ['J', 'K'], label: 'shortcuts.nextPrevious' },
  { keys: ['Alt', 'S'], label: 'shortcuts.saveAsList' },
  { keys: ['?'], label: 'shortcuts.help' },
];

/** The list of keyboard shortcuts, opened with `?` outside fields. */
@Component({
  selector: 'app-shortcut-help',
  template: `<app-dialog
    [(visible)]="visible"
    [header]="'shortcuts.title' | translate"
    [dismissableMask]="true"
    [style]="{ width: '480px' }"
    styleClass="shortcut-help-dialog"
  >
    <table class="shortcut-table">
      <tbody>
        @for (shortcut of shortcuts; track shortcut.label) {
          <tr>
            <th scope="row">
              @for (key of shortcut.keys; track key; let last = $last) {
                <kbd>{{ key }}</kbd>
                @if (!last) {
                  <span class="shortcut-separator"></span>
                }
              }
            </th>
            <td>{{ shortcut.label | translate }}</td>
          </tr>
        }
      </tbody>
    </table>
  </app-dialog>`,
  styleUrls: ['./shortcut-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShortcutHelpComponent implements OnDestroy {
  private changeDetector = inject(ChangeDetectorRef);
  public readonly shortcuts = SHORTCUTS;
  public visible = false;
  private unregister = inject(ShortcutService).register({
    keys: '?',
    handler: () => {
      this.visible = !this.visible;
      this.changeDetector.markForCheck();
    },
  });

  ngOnDestroy() {
    this.unregister();
  }
}
